import React, { useState,useEffect } from 'react';
import { Modal,CircularProgress,Alert, Box, FormControl,Snackbar, Typography, TextField, Tooltip, Button, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { grey, red } from '@mui/material/colors';
import AddIcon from '@mui/icons-material/Add';
import BASE_URL from '../../config'

const style = {
  position: 'absolute', 
  top: '50%', 
  left: '50%', 
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white', 
  borderRadius: 4, 
  p: 4, 
  outline: 'none',
  width: { xs: '90%', sm: '500px' },
  maxHeight: 'auto', 
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  // Ocultar para Firefox
  scrollbarWidth: 'none',
  // Ocultar para Internet Explorer y Edge antiguo
  msOverflowStyle: 'none',
};

export default function Modalnewrol({refresh }) {
  const [tareaData, setTareasData] = useState({ nombre: '',equipo: []});
  const [confirmType, setConfirmType] = useState(null);
  const [open, setOpen] = useState(false);
  const [nombresBD, setNombresBD] = useState([]);
  const [tareasBD, setTareasBD] = useState([]);
  const [loading, setLoading] = useState(false); 
  const [error, setError] = useState(false); 
  
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  
  const isTareaValid = tareaData.nombre.trim().length > 3;
  
  useEffect(() => {
    if (open) {
      const fetchData = async () => {
        try {
          const res = await fetch(`${BASE_URL}/tareas/getequipos`);
          const dataEquipos = await res.json();
          setNombresBD(Array.isArray(dataEquipos) ? dataEquipos : []);
        } catch (err) {
          console.error("Error cargando datos:", err);
        }
      };
      fetchData();
      setTareasData({ nombre: '', equipo: [],});
      setConfirmType(null);
      setError(false);
    }
  }, [open]);

  const handleToggle = (valor, campo) => {
    const listaActual = tareaData[campo];
    const currentIndex = listaActual.indexOf(valor);
    const nuevaLista = [...listaActual];

    if (currentIndex === -1) {
      nuevaLista.push(valor);
    } else {
      nuevaLista.splice(currentIndex, 1);
    }

    setTareasData({ ...tareaData, [campo]: nuevaLista });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'nombre' && value.length > 40) return;
    setTareasData({ ...tareaData, [name]: value });
  };


  const validateAndOpenSave = () => {
    if (!isTareaValid || tareaData.equipo.length === 0 ) {
      setError(true);
    } else {
      setError(false);
      setConfirmType('save');
    }
  };

  const handleClose = () => {
    setOpen(false);
    setConfirmType(null);
    setLoading(false);
    setError(false);
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${BASE_URL}/tareas/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(tareaData)
      });
      const data = await res.json();
      if (res.ok) {
        setSnackbar({ open: true, message: 'Tarea creado con éxito', severity: 'success' });
        setTimeout(() => {
          if(refresh) refresh();
          handleClose();
        }, 1500); 
      } else {
        setError(data.message || 'Error al registrar la tarea.');
        setConfirmType(null); 
        setLoading(false);
      }
    } catch (e) {
      setError('Error de conexión con el servidor.');
      setConfirmType(null);
      setLoading(false);
    }
  };

    const boxstyle = { 
    mx:0.3, 
    my:0.3,  
    maxHeight: '90px',
    overflowY: 'auto', 
    bgcolor: '#ffffff',
  
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: grey[300],
      borderRadius: '8px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: grey[500],
    },
    }

  if (confirmType) {
    return (
      <Modal open={open} onClose={() => setConfirmType(null)}>
        <Box sx={style}>
          <Box sx={{display:'flex',flexDirection:'column',gap:1}}>
            <Typography variant="h6" textAlign="start" >
              {confirmType === 'cancel' ? '¿Cancelar nuevo tarea?' : '¿Crear nueva tarea?'}
            </Typography>
            <Typography variant="body1" color='textSecondary' >
              {confirmType === 'cancel' ? 'Los datos ingresados se perderán.¿Estás seguro que deseas cancelar?' : '¿Estás seguro que deseas crear esta nueva tarea?'}
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, mt:2 , justifyContent:'end' }}>
              <Button fullWidth 
                      variant="contained" 
                      sx={{bgcolor:grey[100], color:'black',textTransform: 'none',width: { xs: '50%', sm: '38%' }}} 
                      onClick={() => setConfirmType(null)}>
                {confirmType === 'cancel' ? 'No, continuar editando' : 'No, revisar datos'}
              </Button>
              <Button fullWidth 
                      variant="contained" 
                      sx={{ bgcolor: 'black', textTransform: 'none',width: { xs: '50%', sm: '25%' } }} 
                      onClick={confirmType === 'cancel' ? handleClose : handleSubmit}>
                      
                      {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> :confirmType === 'cancel' ? 'Sí, cancelar' : 'Sí, guardar'}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    );
  }

  const Inputstyle = {
      '& .MuiOutlinedInput-root': {
        bgcolor: '#f5f5f5',
        borderRadius: '8px',
        '& fieldset': { borderColor: 'transparent' },
        '&:hover fieldset': { borderColor: grey[400] },
        '&.Mui-focused fieldset': { borderColor: grey[600] },
      },
    };
  

  return (
  <>
      <Button onClick={() => setOpen(true)} sx={{ borderRadius: '8px', bgcolor: 'black', textTransform:'none' }} fullWidth variant="contained" startIcon={<AddIcon />}>
        Nueva Tarea
      </Button>
    <Modal open={open} onClose={() => setConfirmType('cancel')}>
      <Box sx={style}>
        {/* FORMULARIO */}
        <Box sx={{display:'flex',gap:2,flexDirection:'column'}}>

          {/* TITULOS */}
          <Box>
            <Typography variant="h6">Registrar Nueva Tarea</Typography>
            <Typography variant="subtitle1" color='textSecondary' >Completa la información de la nueva tarea</Typography>
          </Box>

          {/* NOMBRE */}
          <FormControl>
            <Typography sx={{ mb: 0.5 }}>Nombre de la tarea</Typography>
              <TextField 
                size='small'
                sx={Inputstyle} 
                value={tareaData.nombre}
                name='nombre'
                error={(tareaData.nombre.length > 0 && !isTareaValid) || (error && tareaData.nombre.length === 0)}
                helperText={(tareaData.nombre.length > 0 && !isTareaValid) || (error && tareaData.nombre.length === 0) ? "Ingresa el nombre del contacto de la empresa" : ""}
                onChange={handleInputChange} 
              />
          </FormControl>

          {/* EQUIPOS */}
          <FormGroup>
            <Typography sx={{ mb: 0.5 }}>Equipos</Typography>
            <Tooltip 
              title="Debes seleccionar al menos un equipo" 
              open={error && tareaData.equipo.length === 0} 
              placement="top-end" 
              arrow
              componentsProps={{ tooltip: { sx: { bgcolor: red[700], fontWeight: 'bold' } }, arrow: { sx: { color: red[700] } } }}
            >
              <Box sx={{border: `1px solid 
                    ${error && tareaData.equipo.length === 0 ? red[700] : grey[300]}`, 
                    borderRadius: '8px'}}
              >
                <Box sx={boxstyle}>
                  {nombresBD.length > 0 ? nombresBD.map((item) => (
                    <Box
                      key={item}
                      sx={{
                        ':hover': { bgcolor: grey[100] },
                        display: 'flex',
                        alignItems: 'center',
                        height: '30px',
                        transition: 'background-color 0.2s ease',
                      }}>
                      <FormControlLabel
                        control={
                          <Checkbox 
                            sx={{
                              ml: 1, 
                              color: grey[400], 
                              '&.Mui-checked': { color: 'black' } 
                            }} 
                            size="small" 
                            checked={tareaData.equipo.includes(item)} 
                            onChange={() => handleToggle(item, 'equipo')}
                          />
                        }
                        label={
                          <Typography variant="body2" sx={{ userSelect: 'none', fontWeight: 500 }}>
                            {item}
                          </Typography>
                        }
                        sx={{ margin: 0, width: '100%' }}
                      />
                    </Box>
                  )) : (
                    <Box sx={{ p: 2, textAlign: 'center' }}>
                      <Typography variant="caption" sx={{ color: grey[500], fontStyle: 'italic' }}>
                        No hay equipos registrados.
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>

            </Tooltip>
          </FormGroup>

          {/* BOTONES */}
          <Box sx={{display:'flex',flexDirection:'row',justifyContent:'end'}}>
            <Button  
              variant="contained" 
              color='primary'
              sx={{bgcolor:grey[100], color:'black', width: { xs: '50%', sm: '25%' },textTransform: 'none',mr:1, '&:hover': {bgcolor: grey[200]}}} 
              onClick={() => setConfirmType('cancel')}>
              Cancelar
            </Button>
            <Button 
              variant="contained" 
              sx={{ bgcolor: 'black',ml:1, textTransform: 'none',width: { xs: '50%', sm: '25%' } }} 
              onClick={validateAndOpenSave}
            >
              {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : "Crear tarea"}
            </Button>
          </Box>

        </Box>
      </Box>
    </Modal>
    <Snackbar 
            open={snackbar.open} 
            autoHideDuration={1500} 
            onClose={() => setSnackbar({...snackbar, open: false})} 
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          >
            <Alert severity={snackbar.severity} variant="filled" sx={{ width: '100%', borderRadius: '10px' }}>
              {snackbar.message}
            </Alert>
    </Snackbar>
  </>
  );
}